import { IEntitySimpleDTO } from "../../../libs/coreapi-dto/@types/common";

export interface ISelectedItems {
    ids: string[];
    names: string[];
    items: IEntitySimpleDTO[];
}
export enum MarketingEventStateText {
    Preparation = "Подготовка", // 10
    ActiveForParticipants = "Активно для участников", //20 +
    CompletedByExecutor = "Выполнено исполнителем", //30 +
    ResultApprovalWithCustomer = "Согласование результатов с заказчиком", //40
    ApprovedByCustomer = "Утверждено заказчиком", //50
    Cancelled = "Отменено" //100
}

export enum MarketingEventTypeText {
    PurchaseByQuantity = "Закупки по количеству", //10 +
    PurchaseByAmount = "Закупки по сумме", //20 +
    PurchaseByPackage = "Закупки по пакету", //25 +
    SalesByQuantity = "Продажи по количеству", //30 +
    SalesByAmount = "Продажи по сумме", //40 +
    SalesByPackage = "Продажи по пакету", //45 +
    RemainsMatrix = "Остатки (матрица)", //50 +
    ProductOfTheDay = "Товар дня", //60 +
    Display = "Выкладка", //70 +
    CommercialInput = "Коммерческий ввод", //80 +
    CompensatedDiscounts = "Компенсируемые скидки" //90 +
}